/*
  This file provides the default setup for phone verification flow via modal.
  By default it expects next assumptions to hold:
    1. You have rendered html partial 'shared/phone_verification_modal' on the page
    2. You have form with id: lead-form on the page which serves as a container for the submission of the verification result
    3. There is an input within that form for users phone that has class: user-phone
*/

import { jqUrlUtils, closeDialog } from "javascripts/general_scripts";
import dialogPolyfill from "dialog-polyfill";
import intlTelInput from "intl-tel-input";
import 'intl-tel-input/styles'
import "javascripts/gitb_intl_tel_input";
import { PhoneVerifier } from "javascripts/phone_verifier.js";

/* stylesheet */
import 'stylesheets/modals-itcs.less'

if (typeof window.HTMLDialogElement !== 'function') { // for older browsers that don't support <dialog> element natively
  import('dialog-polyfill/dist/dialog-polyfill.css');
}

jqUrlUtils(); closeDialog();

const phoneConfirmationDialog = document.querySelector('#phone-verification-modal');
dialogPolyfill.registerDialog(phoneConfirmationDialog);

{
  let userPhone = $('.user-phone');
  let phoneVerifier = new PhoneVerifier();
  let userVerificationPhone = $('#verify-phone-input');
  let verificationIti = intlTelInput(userVerificationPhone.get(0), {
    allowExtensions: true,
    numberType: 'FIXED_LINE',
    nationalMode: false,
    autoPlaceholder: false,
    autoHideDialCode: false,
    formatOnDisplay: false,
    loadUtilsOnInit: () => import("intl-tel-input/utils")
  });

  $.phoneVerification = { phoneVerifier, phoneConfirmationDialog, userVerificationPhone, userPhone, verificationIti } // set in jQuery object for global access
}

// Below are defined all modal triggers. They all use references set in $.phoneVerification object.
// Feel free to override them to point to elements of your choice.

$('body').on('dialogClosed', function (event, dialog) {
  if (dialog.id === 'phone-verification-modal') {
    if ($.phoneVerification.phoneVerifier.clearHijackFunc) {
      $.phoneVerification.phoneVerifier.hijackSubmissionCntrlFunc = null;
    }
    $.phoneVerification.phoneVerifier.proceedSubmission(false)
    $.phoneVerification.phoneConfirmationDialog.removeAttribute('open');
  }
});

$.phoneVerification.userPhone.on('change', function() {
  let phone = $(this).val();
  if (phone.length > 0 && phone[0] !== '+') {
    phone = '+' + phone;
  }
  $.phoneVerification.userVerificationPhone.val(phone);
});

$.phoneVerification.userVerificationPhone.on('change', function() {
  if ($(this).parsley().isValid()) {
    $(this).val($.phoneVerification.verificationIti.getNumber()); // formatting number to be a string without spaces and special characters, like: +14334445521
  }

  $.phoneVerification.userPhone.val($(this).val());
});

$('.send-code-trigger').on('click', async function(event) {
  
  $.phoneVerification.userVerificationPhone.parsley().validate();
  if (!$.phoneVerification.userVerificationPhone.parsley().isValid()) {
    event.stopPropagation(); // prevent from bubbling, to avoid locking the button
    return;
  }
  $.phoneVerification.userVerificationPhone.val($.phoneVerification.verificationIti.getNumber()); // ensure number is properly formatted, like: +14334445521
  const countryData = $.phoneVerification.verificationIti.getSelectedCountryData();

  if (!window.PHONE_VERIFIABLE_COUNTRIES.includes(countryData.iso2)) { // this means that user changed his phone number and is no longer a valid candidate for phone verification
    $(this).attr('disabled', 'disabled');
    await $.phoneVerification.phoneVerifier.updateUsersPhone(); // for this to work you need to provide $.phoneVerification.phoneVerifier with userId
    $.phoneVerification.phoneVerifier.proceedSubmission(false);
  } else {
    await $.phoneVerification.phoneVerifier.sendVerificationCode();
    $.rails.enableElement($(this)); // because callback function is async, rails-ujs cannot reenable trigger button
  }
});

$('.resend-code-trigger').on('click', function() {
  $.phoneVerification.phoneVerifier.resendVerificationCode();
});

$('.confirm-code-panel-trigger').on('click', function() {
  $.phoneVerification.phoneVerifier.showConfirmCodePanel();
});

$('.verify-code-trigger').on('click', function() {
  $(this).attr('disabled', 'disabled');
  $.phoneVerification.phoneVerifier.verifyCode(this);
});

$('.edit-phone-panel-trigger').on('click', function() {
  $.phoneVerification.phoneVerifier.showEditPhonePanel();
});

$('.skip-button').on('click', function () {
  $.phoneVerification.phoneVerifier.proceedSubmission(false)
});
